/**
 * Scroll-reveal — the .in engine sets data-animation="true" on a section once
 * it enters the viewport and the SCSS animates from there. Ported as an
 * IntersectionObserver instead of .in's scroll-offset arithmetic; same
 * attribute contract, so the migrated styles behave identically.
 */
export function checkIfInViewport(selector = '[data-v8-homepage-header], section') {
  const nodes = Array.prototype.slice.call(document.querySelectorAll(selector));
  if (nodes.length === 0 || !('IntersectionObserver' in window)) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-animation', 'true');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -150px 0px' },
  );

  nodes.forEach((node) => io.observe(node));
}
